import { Lightning, Utils } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { Recipes, urlWithRecipe } from '../../Business/utility/ImageRecipeUtil';
import { ProfileEditPage } from '../../pages/profile/ProfileEditPage';

const _constants = {
  cardWidth: 200,
  radius: 10,
  borderWidth: 5,
  iconSize: 35,
  addIconSize: 100,
};

export class ProfileCard extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: _constants.cardWidth,
      h: _constants.cardWidth * 1.5,
      color: Theme.Colors.Transparent,
      rect: true,
      ProfileImage: {
        x: 3,
        y: 3,
        w: _constants.cardWidth - 6,
        h: _constants.cardWidth - 6,
      },
      Border: {
        x: 0,
        y: 0,
        w: _constants.cardWidth,
        h: _constants.cardWidth,
        rect: true,
        clip: true,
        visible: false,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: _constants.radius,
          stroke: _constants.borderWidth,
          strokeColor: Theme.Colors.Primary,
          fillColor: Theme.Colors.Transparent,
        },
      },
      ProfileName: {
        x: w => w / 2,
        y: _constants.cardWidth + 10,
        mountX: 0.5,
        text: {
          ...Theme.Fonts.Normal,
          text: 'Profile name',
          textAlign: 'center',
          fontSize: 26,
          wordWrapWidth: _constants.cardWidth,
          textOverflow: 'ellipsis',
          maxLines: 1,
        },
      },
      EditIcon: {
        visible: false,
        mountX: 0.5,
        mountY: 1,
        x: _constants.cardWidth / 2,
        y: _constants.cardWidth * 1.5,
        w: _constants.iconSize,
        h: _constants.iconSize,
        src: Utils.asset('images/profile/ic_edit_profile.png'),
      },
    };
  }

  _init() {
    // console.log(this.data);
    this._down = false;
    if (this.data) {
      this.tag('ProfileName').text.text = this.data.profile.name;
      this.tag('ProfileImage').src = urlWithRecipe(this.data.image, Recipes.Profile.Large);
    } else {
      this.tag('ProfileName').text.text = this.backend.translations.forKey('profile_new');
      this.tag('EditIcon').visible = false;
      this.tag('ProfileImage').patch({
        src: Utils.asset('images/profile/ic_profile_plus.png'),
        color: Theme.Colors.White,
        mount: 0.5,
        x: _constants.cardWidth / 2,
        y: _constants.cardWidth / 2,
        w: _constants.addIconSize,
        h: _constants.addIconSize,
      });
    }
  }

  _focus() {
    if (this.data) {
      this.tag('Border').visible = true;
      this.tag('EditIcon').visible = true;
      this.tag('EditIcon').color = Theme.Colors.White;
    } else {
      this.tag('ProfileImage').color = Theme.Colors.Primary;
    }
  }

  _unfocus() {
    if (this.data) {
      this.tag('Border').visible = false;
      this.tag('EditIcon').visible = false;
    } else {
      this.tag('ProfileImage').color = Theme.Colors.White;
    }
    this._down = false;
  }

  _handleUp() {
    if (this.data) {
      this._down = false;
      this.tag('Border').visible = true;
      this.tag('EditIcon').color = Theme.Colors.White;
    }
  }

  _handleDown() {
    if (this.data) {
      this._down = true;
      this.tag('Border').visible = false;
      this.tag('EditIcon').color = Theme.Colors.Primary;
    }
  }

  _handleEnter() {
    if (!this.data) {
      // new account
      this.fireAncestors('$openDialog', { type: ProfileEditPage, data: undefined, backend: this.backend }, true);
    } else if (this._down) {
      // console.log('Edit');
      this.fireAncestors(
        '$openDialog',
        { type: ProfileEditPage, data: this.data, backend: this.backend, allowDelete: !this.data.master },
        true
      );
    } else {
      // console.log('Select');
      this.fireAncestors('$switchProfile', this.data.id);
      this.fireAncestors('$closeModal');
    }
  }
}
